import dayjs from "dayjs";
import { date, number, object, string } from "yup";

export const DEFAULT_VALUES = {
  transactionDate: dayjs(),
};

export const VALIDATION_SCHEMA = object().shape({
  transactionDate: date().required("Harus diisi"),
  expenseCategory: object().required("Harus diisi"),
  amount: number()
    .required("Harus diisi")
    .transform((value) => (isNaN(value) ? 0 : value))
    .min(1, "Minimal 1"),
  note: string()
    .nullable()
    .transform((val) => (val === "" ? null : val)),
});
